module.exports = __webpack_public_path__ + "media/pro/rectangle-right-95209595.svg";